import { gql } from '@apollo/client';

export const GET_ADDRESS_LOCATION_REVIEW_BY_ID = gql`
  query GetAddressLocationReviewById($id: Long!) {
    getAddressLocationReviewById(id: $id) {
      id
      requestId
      bizNo
      reportSource
      originalAddress
      originalAddressFormatted
      standardAddress
      latitude
      longitude
      reportedLatitude
      reportedLongitude
      driverLatitude
      driverLongitude
      deliveredLatitude
      deliveredLongitude
      approvedLatitude
      approvedLongitude
      reportedPrimaryTypeCode
      reportedSecondaryTypeCode
      approvedPrimaryTypeCode
      approvedSecondaryTypeCode
      status
      podImageUrls
    }
  }
`;

export interface AddressLocationReviewDetailType {
  id: number;
  requestId: string;
  bizNo: string;
  reportSource: 'DRIVER' | 'BACKEND';
  originalAddress: string;
  originalAddressFormatted: string;
  standardAddress: string;
  latitude: string;
  longitude: string;
  reportedLatitude: string;
  reportedLongitude: string;
  driverLatitude: string | null;
  driverLongitude: string | null;
  deliveredLatitude: string | null;
  deliveredLongitude: string | null;
  approvedLatitude: string | null;
  approvedLongitude: string | null;
  reportedPrimaryTypeCode: string | null;
  reportedSecondaryTypeCode: string | null;
  approvedPrimaryTypeCode: string | null;
  approvedSecondaryTypeCode: string | null;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  // POD 照片下载 URL，最多 5 张，无则为空数组
  podImageUrls: string[];
}

export interface GetAddressLocationReviewByIdResponse {
  getAddressLocationReviewById: AddressLocationReviewDetailType | null;
}

